"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var Skeleton = function Skeleton(props) {
  var type = props.type,
    className = props.className,
    style = props.style,
    id = props.id,
    _a = props.width,
    width = _a === void 0 ? 200 : _a,
    _b = props.height,
    height = _b === void 0 ? 100 : _b,
    _c = props.borderRadius,
    borderRadius = _c === void 0 ? 2 : _c,
    w = props.w,
    h = props.h,
    x = props.x,
    y = props.y,
    radius = props.radius;
  return react_1["default"].createElement(react_1["default"].Fragment, null, type === 'charts' ? react_1["default"].createElement(odc_frame_1["default"], {
    style: __assign({}, style),
    className: (0, classnames_1["default"])('odc-skeleton-charts', className)
  }) : react_1["default"].createElement(odc_frame_1["default"], __assign({}, (0, spaui_utils_1.globalProps)(id, {
    withDefaultClassName: false,
    supportAllEvents: true
  }, Skeleton), {
    className: (0, classnames_1["default"])('odc-skeleton', className),
    x: x,
    y: y,
    style: __assign({
      width: w || width,
      height: h || height,
      borderRadius: _typeof(radius) !== undefined ? undefined : borderRadius
    }, style),
    radius: radius
  })));
};
(0, spaui_utils_1.setComponentMark)(Skeleton, info_1["default"]);
exports["default"] = react_1["default"].memo(Skeleton);